// startup
// Load entry module and return exports
__webpack_require__("./resources/js/helper/polyfill.js");
// This entry module is referenced by other modules so it can't be inlined
__webpack_require__("./resources/libs/non_critical/masonry/masonry.pkgd.min.js");
__webpack_require__("./components/com_accordion_faq/js/script.js");
__webpack_require__("./components/com_application_tiles/js/script.js");
__webpack_require__("./components/com_employees/js/script.js");
__webpack_require__("./components/com_filelist/js/script.js");
__webpack_require__("./components/com_image-slider/js/script.js");
__webpack_require__("./components/com_imagebanner/js/script.js");
__webpack_require__("./components/com_news/js/script.js");
__webpack_require__("./components/com_product_world_clinic/js/script.js");
__webpack_require__("./components/com_product_world_patient/js/script.js");
__webpack_require__("./components/com_products/js/script.js");
__webpack_require__("./components/com_testimonials/js/script.js");
__webpack_require__("./components/com_three-tiles/js/script.js");
__webpack_require__("./components/com_video/js/script.js");
var __webpack_exports__ = __webpack_require__("./resources/js/index.js");
